import React from "react";

const tableHeaderColumns = ["ID", "Username", "Company", "Orders", "Last Active"];

const data = [
  {
    clientId: "C123",
    username: "Acme Inc.",
    company: "John Doe",
    orders: 50,
    lastActive: "2022-03-15",
  },
  {
    clientId: "C456",
    username: "Widget Co.",
    company: "Jane Doe",
    orders: 75,
    lastActive: "2022-03-17",
  },
  {
    clientId: "C789",
    username: "ABC Corp.",
    company: "Bob Smith",
    orders: 100,
    lastActive: "2022-03-19",
  },
  {
    clientId: "C012",
    username: "XYZ Ltd.",
    company: "Samantha Lee",
    orders: 40,
    lastActive: "2022-03-14",
  },
  {
    clientId: "C345",
    username: "123 Industries",
    company: "David Kim",
    orders: 25,
    lastActive: "2022-03-16",
  },
  {
    clientId: "C678",
    username: "Global Enterprises",
    company: "Emily Chen",
    orders: 150,
    lastActive: "2022-03-18",
  },
  {
    clientId: "C901",
    username: "Innovative Solutions",
    company: "Michael Nguyen",
    orders: 60,
    lastActive: "2022-03-20",
  },
  {
    clientId: "C234",
    username: "Dynamic Technologies",
    company: "Lauren Wu",
    orders: 90,
    lastActive: "2022-03-13",
  },
  {
    clientId: "C567",
    username: "Future Horizons",
    company: "Chris Garcia",
    orders: 110,
    lastActive: "2022-03-16",
  },
  {
    clientId: "C890",
    username: "Visionary Concepts",
    company: "Sarah Martinez",
    orders: 45,
    lastActive: "2022-03-19",
  },
];

export default function ClientsTablePreview() {
  const columnWidths = ["2.5%", "30%", "25%", "2.5%", "30%"];
  
  return (
    <table className="w-full text-sm text-left text-gray-700 dark:text-gray-400">
      <thead className="text-sm text-gray-900 bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
        {tableHeaderColumns.map((column) => (
          <th scope="col" className="px-6 py-3">
            <button>{column}</button>
          </th>
        ))}
      </thead>
      <tbody>
        {data &&
          data.map((dataItem) => (
            <tr
              className="cursor-pointer bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
              key={dataItem.clientId}
            >
              <td className="px-4 py-2" style={{ width: columnWidths[0] }}>{dataItem.clientId}</td>
              <td className="px-4 py-2" style={{ width: columnWidths[1] }}>{dataItem.username}</td>
              <td className="px-4 py-2" style={{ width: columnWidths[2] }}>{dataItem.company}</td>
              <td className="px-4 py-2" style={{ width: columnWidths[3] }}>{dataItem.orders}</td>
              <td className="px-4 py-2" style={{ width: columnWidths[4] }}>{(new Date(dataItem.lastActive)).toDateString()}</td>
            </tr>
          ))}
      </tbody>
    </table>
  );
}
